import { render, staticRenderFns } from "./Prioritarias.vue?vue&type=template&id=637629ca&scoped=true"
import script from "./Prioritarias.vue?vue&type=script&lang=js"
export * from "./Prioritarias.vue?vue&type=script&lang=js"
import style0 from "./Prioritarias.vue?vue&type=style&index=0&id=637629ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637629ca",
  null
  
)

export default component.exports